import React from "react"
import { NavDropdown } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import { twClassNames } from "../helpers"
import flag_fi from "../assets/language_fi.png"
import flag_en from "../assets/language_en.png"

type LanguagePickerProps = {
  absolute?: boolean
  className?: string
}

const LanguagePicker: React.FC<LanguagePickerProps> = ({ absolute = false, className = "" }) => {
  const { i18n, t } = useTranslation()

  const changeLanguage = (lang: string) => {
    // Update application language
    i18n.changeLanguage(lang)
    document.documentElement.lang = lang
  }

  return (
    <NavDropdown
      id="language-picker-dropdown"
      alignRight
      title={
        <img
          src={i18n.resolvedLanguage === "fi" ? flag_fi : flag_en}
          alt="Language picker flag"
          width="28"
          height="20"
          className="language-picker-flag"
        />
      }
      className={twClassNames(className, absolute && "language-picker")}>
      <NavDropdown.Header>{t("header.languagePicker.title")}</NavDropdown.Header>
      <NavDropdown.Item onClick={() => changeLanguage("en")}>
        <img src={flag_en} alt="English flag" width="18" height="18" />
        <span className="tw-pl-2">English - EN</span>
      </NavDropdown.Item>
      <NavDropdown.Item onClick={() => changeLanguage("fi")}>
        <img src={flag_fi} alt="Finnish flag" width="18" height="18" />
        <span className="tw-pl-2">Suomeksi - FI</span>
      </NavDropdown.Item>
    </NavDropdown>
  )
}

export default LanguagePicker
